const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

import Votingtimer from './contestants/Votingtimer.jsx';
import TotalVoteCount from './contestants/TotalVoteCount.jsx';
import VotingNavigation from './contestants/VotingNavigation.jsx';
import ContestantGrid from './contestants/ContestantGrid.jsx';
import ContestantList from './contestants/ContestantList.jsx';
import Submitform from './contestants/Submitform.jsx';
import Title from './contestants/Title.jsx';
import ToptenContestant from './contestants/ToptenContestant.jsx';
import RulesContestant from './contestants/RulesContestant.jsx';
import ProfileContestant from './contestants/ProfileContestant.jsx';
import ShowmessageContest from './contestants/ShowmessageContest.jsx';
import LimitMessage from './contestants/LimitMessage.jsx';
import Logincontest from './Logincontest.jsx';
import CriticalError from './CriticalError.jsx';

//Action to save and fetch data
import { fetchFrontSetting, frontsingleimmute, insertPayment, updateFrontData, stripePayment, couponApply, frontimmute, fetchposts, fetchjudgetopten, Userlogout } from '../actions/front_actions';

//Import Designs
import { Container, Grid2, Snackbar, Backdrop, CircularProgress } from '@mui/material';
import RemainingBonusVotes from './contestants/RemainingBonusVotes.jsx';
import RemainingBuyVotes from './contestants/RemainingBuyVotes.jsx';

let current_date = null;
class Showcontestants extends Component {

    constructor(props) {
        super(props);
        this.state = { language: "en", listgrid: "grid", wait: 0, form_val: null, short: this.props.shortagrument, setlimit: false };
    }

    componentDidMount = () => {
        this.setState({ wait: 1 })
        this.props.fetchFrontSetting(this.props.SITE_URL, this.props.shortagrument.id).then(res => {
            if (this.state.listgrid == 'grid' && !this.props.shortagrument.view) {
                let direction = res.selcategoryoptions?.style?.direction || res.settings?.style?.direction;
                let listgrid = (direction == 'column' ? 'list' : 'grid');
                this.setState({ listgrid: listgrid });
            }
        });

        if (typeof this.props.shortagrument !== "undefined") {
            let showcontest = this.props.shortagrument.showcontestants;
            let flag_code = this.props.shortagrument.flag_code;

            if (showcontest == 0)
                this.setState({ listgrid: 'upcoming' });
            else if (flag_code == 'profile')
                this.setState({ listgrid: 'profile_screen' });
            else if (flag_code == 'topcontest')
                this.setState({ listgrid: 'topcontest' });
            else
                this.setState({ listgrid: this.props.shortagrument.view });

            if (this.props.shortagrument.openform == 'on') {
                if (flag_code == 'profile') {
                    this.setState({ form_val: '' });
                } else
                    this.setState({ form_val: 'submit_form' });
            }
        }
        this.setState({ wait: 0 })
    }

    handleDrawer = (val) => {
        this.props.frontimmute('drawer', val);
    }

    handleGrid = (view) => {
        this.setState({ wait: 1 })
        this.setState({ listgrid: view });
        this.setState({ wait: 0 })
    }

    handleLimitClose = () => {
        this.setState({ setlimit: false });
    }

    handleform = (form) => {
        this.setState({ wait: 1 });

        if (this.handleLimitCheck() === true) {
            this.setState({ setlimit: true });
        }
        else {
            if (this.state.form_val == 'submit_form') {
                this.setState({ form_val: '' });
            } else {
                this.setState({ form_val: form });
            }
        }
        this.setState({ wait: 0 })
    }

    handleLimitCheck = () => {
        //Entry Limit
        const { entrycount } = this.props.model;
        const { vote_contest_entry_person } = this.props.shortagrument.allcatoption || "";
        if (entrycount !== null && vote_contest_entry_person != 0 && vote_contest_entry_person !== null) {
            if (parseInt(entrycount) >= parseInt(vote_contest_entry_person)) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    handlegallery = (view) => {
        this.setState({ wait: 1 })
        this.setState({ listgrid: view, form_val: '' });
        this.setState({ wait: 0 })
    }

    handletopten = (view) => {
        this.setState({ wait: 1 })
        this.setState({ listgrid: view, form_val: '' });
        this.setState({ wait: 0 })
    }

    handlerules = (view) => {
        this.setState({ wait: 1 })
        this.setState({ listgrid: view, form_val: '' });
        this.setState({ wait: 0 })
    }

    handleurprofile = (view) => {
        this.setState({ wait: 1 })
        this.setState({ listgrid: view, form_val: '' });
        this.setState({ wait: 0 })
    }

    //Immutable functions
    handleValueChange = externalId => (event) => {
        this.props.frontsingleimmute(externalId, event.target.name, event.target.value);
    }

    handleFileChange = externalId => (event) => {
        let file = event.target.files[0];
        this.props.frontsingleimmute(externalId, event.target.name, file);
    }

    handleValueDate = externalId => (event) => {
        const find_editor = externalId.split('--');
        const arlength = find_editor.length;
        if (arlength >= 1) {
            const value = event;
            this.props.frontsingleimmute(find_editor[0], find_editor[1], value);
        }
    }

    handleValueCheckbox = externalId => (event, isChecked) => {
        let name = event.target.name;
        let get_previous_val = this.props.model.contestant_form[name];
        if (isChecked) {
            if (get_previous_val == '') {
                this.props.frontsingleimmute(externalId, event.target.name, event.target.value);
            } else {
                let add_val = get_previous_val + "," + event.target.value;
                this.props.frontsingleimmute(externalId, event.target.name, add_val);
            }
        } else {
            if (get_previous_val != '') {
                let new_string = get_previous_val.replace(',' + event.target.value, '');
                let new_string_val = new_string.replace(event.target.value + ',', '');
                let new_string_vl = new_string_val.replace(event.target.value, '');
                this.props.frontsingleimmute(externalId, event.target.name, new_string_vl);
            }
        }
    }

    handleValueEditor = externalId => (event) => {
        let editor_val = (event.srcElement === undefined) ? event : event.srcElement.innerHTML;
        this.props.frontsingleimmute('contestant_form', externalId, editor_val);
    }

    paymentChange = (argument, payment_entry_open) => {
        this.props.updateFrontData(argument, payment_entry_open);
    }

    insertPayment = (gateway, details, amount, currency = '') => {
        this.props.insertPayment(this.props.SITE_URL, gateway, details, amount, currency);
    }

    stripePayment = (amount) => {
        this.props.stripePayment(this.props.SITE_URL, amount);
    }

    couponApply = (gateway, coupon, term_id) => {
        return this.props.couponApply(this.props.SITE_URL, gateway, coupon, term_id);
    }

    handleSearchChange = externalId => (event) => {
        let values = event.target.value;
        this.props.frontimmute('wpvc_search', event.target.value);
    }

    handleSearchClick = (wpvc_search) => {
        this.setState({ wait: 1 });
        if (this.state.listgrid !== 'grid' && this.state.listgrid !== 'list') {
            this.setState({ listgrid: 'grid' });
        }
        else {
            this.setState({ listgrid: this.state.listgrid });
        }
        this.props.frontimmute('paginate_value', 1);
        this.props.fetchposts(this.props.SITE_URL, this.props.shortagrument.id, this.props.shortagrument, 1, "", wpvc_search);
        if (wpvc_search == "") {
            this.props.frontimmute('wpvc_search', "");
            this.props.frontimmute('wpvc_search_active', 0);
        }
        else {
            this.props.frontimmute('wpvc_search_active', 1);
        }
        this.setState({ wait: 0 })
    }

    handleSearchListing = () => {
        let wpvc_search = "";
        if (typeof this.props.model.wpvc_search !== "undefined") {
            wpvc_search = this.props.model.wpvc_search;
        }
        return wpvc_search;
    }

    handleSortSelect = () => {
        let wpvc_sort = "";
        if (typeof this.props.model.wpvc_sort !== "undefined") {
            wpvc_sort = this.props.model.wpvc_sort;
        }
        return wpvc_sort;
    }

    handleSorting = (event) => {
        this.setState({ wait: 1 });
        let values = event.currentTarget.dataset.value;
        let sortSet = {};
        let wpvc_search = this.handleSearchListing();
        if (this.state.listgrid !== 'grid' && this.state.listgrid !== 'list') {
            this.setState({ listgrid: 'grid' });
        }
        else {
            this.setState({ listgrid: this.state.listgrid });
        }
        if (typeof this.props.model.wpvc_old_orderby === "undefined") {
            this.props.frontimmute('wpvc_old_orderby', this.props.shortagrument.orderby);
            this.props.frontimmute('wpvc_old_order', this.props.shortagrument.order);
        }

        switch (values) {
            case 'newest':
                sortSet = { 'orderby': 'id', 'order': 'desc' };
                break;
            case 'oldest':
                sortSet = { 'orderby': 'id', 'order': 'asc' };
                break;
            case 'mostvoted':
                sortSet = { 'orderby': 'votes', 'order': 'desc' };
                break;
            case 'leastvoted':
                sortSet = { 'orderby': 'votes', 'order': 'asc' };
                break;
            case 'mostjudged':
                sortSet = { 'orderby': 'wpvc_judge_score', 'order': 'desc' };
                break;
            case 'leastjudged':
                sortSet = { 'orderby': 'wpvc_judge_score', 'order': 'asc' };
                break;
        }

        sortSet = Object.assign(this.props.shortagrument, sortSet);
        this.props.fetchposts(this.props.SITE_URL, this.props.shortagrument.id, sortSet, 1, "", wpvc_search);
        this.props.frontimmute('wpvc_sort', values);
        this.setState({ wait: 0 })
    }

    render() {
        const { t } = this.props;
        if (this.props?.model?.term_not_exists == 1) {
            return t('no_category_exists');
        }
        const shortatts = this.props.shortagrument;
        const values = this.props.model;
        const onlyloggedsubmit = shortatts.onlyloggedsubmit;
        const check_logged = shortatts.user_logged;
        if ((values) && (this.state.wait != 1)) {
            const color = this.props.model.settings.color;
            current_date = new Date(values.current_date);
            let submitentry;
            if (this.state.form_val == 'submit_form') {
                submitentry = 1;
            } else {
                submitentry = 0;
            }

            let limitCheck;
            limitCheck = this.handleLimitCheck() === false ? 1 : 0;
            let onlylogged_submit_state = (onlyloggedsubmit == 1 && check_logged == false && shortatts.openform == 'on' && this.props.shortagrument.showform != 0) ? 1 : 0;

            return (
                <Container className="wpvc_showcontestant_container">
                    <Snackbar open={this.state.setlimit} autoHideDuration={6000} onClose={this.handleLimitClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                        <LimitMessage setopen={this.state.setlimit} handleLimitClose={this.handleLimitClose} />
                    </Snackbar>
                    {this.props.shortagrument.title != null &&
                        <Title
                            short={shortatts}
                        />
                    }
                    <Grid2 container className="wpvc_timer_count_container" direction="row" justifyContent="space-between" alignItems="center">
                        {this.props.shortagrument.showtimer == 1 &&
                            <Votingtimer
                                {...color}
                                short={shortatts}
                                currentdate={current_date}
                                {...values}
                            />
                        }
                        {this.props.model.selcategoryoptions?.total_vote_count === 'on' &&
                            <TotalVoteCount
                                values={values}
                            />
                        }
                        {this.props.model.settings?.referral?.referral_enable === 'on' &&
                            <RemainingBonusVotes
                                values={values}
                            />
                        }

                        {this.props.model.selcategoryoptions?.wpvc_category_buyvotes_settings == "on" && this.props.model.settings?.wpvc_buyvotes_settings?.ow_buyvotes_split_votes === 'on' &&
                            <RemainingBuyVotes
                                values={values}
                            />
                        }
                    </Grid2>
                    {this.props.shortagrument.navbar == 1 &&
                        <VotingNavigation
                            {...values}
                            {...color}
                            short={shortatts}
                            SITE_URL={this.props.SITE_URL}
                            handleDrawer={this.handleDrawer}
                            handlelogout={() => this.props.Userlogout(this.props.SITE_URL)}
                            handleview={this.handleGrid}
                            handleform={this.handleform}
                            handlegallery={this.handlegallery}
                            handletopten={this.handletopten}
                            handlerules={this.handlerules}
                            handleurprofile={this.handleurprofile}
                            searchchange={this.handleSearchChange}
                            searchclick={this.handleSearchClick}
                            sortchange={this.handleSorting}
                            sortselect={this.handleSortSelect}
                            view={this.state.listgrid}
                            sortshow="1"
                            hide_grid="1"
                            currentdate={current_date}
                        />
                    }

                    {
                        this.props.model.criticalError !== undefined &&
                        <CriticalError msg={this.props.model.criticalError} />
                    }

                    {
                        onlylogged_submit_state == 1 &&
                        <div className="wpvc_not_loggedin">
                            <Logincontest {...values} short={shortatts} SITE_URL={this.props.SITE_URL}
                                ORIGINAL_URL={this.props.ORIGINAL_URL} CONSTANT={this.props.CONSTANT} />
                        </div>
                    }

                    {submitentry == 1 && limitCheck == 1 && onlylogged_submit_state == 0 &&
                        <Submitform
                            {...values}
                            short={shortatts}
                            SITE_URL={this.props.SITE_URL}
                            ORIGINAL_URL={this.props.ORIGINAL_URL}
                            valchange={this.handleValueChange}
                            filechange={this.handleFileChange}
                            ediorchange={this.handleValueEditor}
                            checkboxchange={this.handleValueCheckbox}
                            datepickerchange={this.handleValueDate}
                            paymentchange={this.paymentChange}
                            insertPayment={this.insertPayment}
                            stripePayment={this.stripePayment}
                            couponApply={this.couponApply}
                            currentdate={current_date}
                        />
                    }

                    {this.state.listgrid == 'grid' &&
                        <ContestantGrid {...values}
                            view={this.state.listgrid}
                            short={shortatts}
                            SITE_URL={this.props.SITE_URL}
                            CONSTANT={this.props.CONSTANT}
                            search={this.handleSearchListing}
                            currentdate={current_date}
                        />
                    }

                    {this.state.listgrid == 'gallery' &&
                        <ContestantGrid {...values}
                            view="grid"
                            short={shortatts}
                            SITE_URL={this.props.SITE_URL}
                            CONSTANT={this.props.CONSTANT}
                            search={this.handleSearchListing}
                            currentdate={current_date}
                        />
                    }

                    {(this.state.listgrid == 'topten' || this.state.listgrid == 'topcontest') &&
                        <ToptenContestant {...values}
                            view="grid"
                            short={shortatts}
                            SITE_URL={this.props.SITE_URL}
                            CONSTANT={this.props.CONSTANT}
                            currentdate={current_date}
                        />
                    }

                    {wp.hooks.applyFilters('wpvc_judge_show_top10', '', this.props, this.state.listgrid)}

                    {this.state.listgrid == 'rules' &&
                        <RulesContestant {...values}
                            short={shortatts}
                            SITE_URL={this.props.SITE_URL}
                            CONSTANT={this.props.CONSTANT}
                            currentdate={current_date}
                        />
                    }

                    {(this.state.listgrid == 'profile' || this.state.listgrid == 'profile_screen') &&
                        <ProfileContestant {...values}
                            view="grid"
                            profile_view={this.state.listgrid}
                            short={shortatts}
                            SITE_URL={this.props.SITE_URL}
                            ORIGINAL_URL={this.props.ORIGINAL_URL}
                            CONSTANT={this.props.CONSTANT}
                            valchange={this.handleValueChange}
                            filechange={this.handleFileChange}
                            ediorchange={this.handleValueEditor}
                            checkboxchange={this.handleValueCheckbox}
                            datepickerchange={this.handleValueDate}
                            currentdate={current_date}
                        />
                    }

                    {this.state.listgrid == 'list' &&
                        <ContestantList {...values}
                            view={this.state.listgrid}
                            short={shortatts}
                            SITE_URL={this.props.SITE_URL}
                            CONSTANT={this.props.CONSTANT}
                            search={this.handleSearchListing}
                            currentdate={current_date}
                        />
                    }

                    {(this.props.shortagrument == 'no_upcoming_contest' || this.props.shortagrument == 'no_ended_contest') &&
                        <ShowmessageContest message={this.props.shortagrument} />
                    }
                </Container>
            )
        } else {
            return <Backdrop className="wpvc_back_loader" open={true}>
                <CircularProgress color="inherit" />
            </Backdrop>
        }
    }
}

const settingstate = state => {
    return { model: state.wpvcfrontdata };
}

export default connect(settingstate, { frontsingleimmute, fetchFrontSetting, updateFrontData, insertPayment, stripePayment, couponApply, frontimmute, fetchposts, fetchjudgetopten, Userlogout })(withTranslation("translations")(Showcontestants));